// Transporte un fichier déposé depuis l'action rapide (tableau de bord) vers la page /depot.
let pending = null;
export const setPendingFile = (f) => { pending = f || null; };
export const takePendingFile = () => { const f = pending; pending = null; return f; };
